<template>
  <card :class="['deployment-checklist']">
    <card-title color="white" v-html="$lang.developmentAndDeploymentChecklist" :bg-color="$root.colors.primary" :bg-color-lightness="$root.colors.bgColorLightness" />
    <card-text>
      <alert v-model="info" :class="['my-1']">{{ $lang.developmentAndDeploymentChecklistInfo }}</alert>
      <alert v-model="done" type="success" :class="['my-1']" v-if="every">{{ $lang.developmentAndDeploymentChecklistSuccess }}</alert>
      <list v-if="checklist.length">
        <list-item v-for="(item, index) in checklist" :key="index" @click="toggle(index)" :class="[item.done ? 'opacity-50' : null]">
          <list-item-icon>
            <checkbox :icon-color="item.done ? null : $root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="item.done" :class="['pointer-events-none']" />
          </list-item-icon>
          <list-item-content>
            <list-item-content-title v-html="item.step" :class="[item.done ? 'line-through' : null]" />
          </list-item-content>
          <list-item-icon>
            <icon :name="`numeric-${index + 1}-box`" :color="item.done ? null : $root.$colors.primary" :color-lightness="$root.$colors.bgColorLightness" />
          </list-item-icon>
        </list-item>
      </list>
    </card-text>
  </card>
</template>
<script>
import methods from '../mixins/methods'

export default {
  name: 'DeploymentChecklist',
  data () {
    return {
      info: true,
      done: true,
      checklist: [],
      storageKey: 'development_deployment_and_publishing_checklist'
    }
  },
  mixins: [
    methods
  ],
  mounted () {
    this.init()
  },
  computed: {
    every () {
      return this.checklist.every(item => item.done === true)
    }
  },
  methods: {
    toggle (index) {
      const item = this.checklist[index]
      item.done = !item.done
      this.setInSessionStorage()
    },
    setInSessionStorage () {
      sessionStorage.setItem(this.storageKey, JSON.stringify(this.checklist))
    },
    init () {
      const key = this.storageKey
      const data = sessionStorage.getItem(key)
      if (!data) {
        this.getExternalData('deployment-checklist.json', 'checklist', 'GET', () => {
          this.setInSessionStorage()
        })
      } else {
        this.checklist = JSON.parse(data)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/deployment-checklist.vue